import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'
import { baseApi } from './api/baseApi'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // RTK default warn ở 32ms — state RTK Query của hệ (factory rows,
      // matching, futures…) đủ lớn để serialize check vượt ngưỡng trong
      // dev mode → console spam. Nâng threshold lên 128ms để giữ safety
      // net cho payload thật sự bloat, nhưng không nhiễu normal ops.
      // Cả 2 check tự disable trong production build nên không ảnh hưởng.
      serializableCheck: { warnAfter: 128 },
      immutableCheck: { warnAfter: 128 },
    }).concat(apiSlice.middleware, baseApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Re-export typed Redux hooks (synced source imports `from '@/store'`).
export { useAppDispatch, useAppSelector } from '../hooks/redux'
